import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonFormatting
  from 'components/atoms/Editors/EditorMenuButtonFormatting/EditorMenuButtonFormatting.styles';
import TextFields from '@mui/icons-material/TextFields';

const EditorMenuButtonFormatting = React.forwardRef((props, ref) => {
  const {
    variant,
    ...innerProps
  } = useComponentProps(props, 'EditorMenuButtonFormatting');

  return <StyledEditorMenuButtonFormatting buttonRef={ref} {...innerProps}
                                           value="formatting"
                                           size="small"
                                           IconComponent={TextFields}/>
});

EditorMenuButtonFormatting.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonFormatting;
